export enum CategoryTypesEnum {
  PROFILE = 0,
  SERVICE = 1,
  INDUSTRY = 2,
}
